import {createAsyncThunk} from "@reduxjs/toolkit";
import {StepValidationPayload} from "wolf/components/organisms/o-heating-form/o-heating-form.types";
import {RootState} from "../..";
import {getFileslotId} from "../../../components/utils";
import {StepsState, StepTemplate} from "../../../model/global";
import Api, {FinalFormPayload} from "../services/thunkApi/api";


export const validateStep = createAsyncThunk('heatingAppSlice/validateStep', async (_, thunkAPI) => {
	const state = thunkAPI.getState() as RootState;

	// get current step index
	const activeIndex = state.steps.activeStepIndex;
	// get step template name
	const { stepTemplate } = state.steps.steps[activeIndex]
	// get current step field data for a payload
	const stepSummary = state.steps.formSummary.steps[stepTemplate]
	// get endpoint for validation
	const endpoint: string = state.steps.steps[activeIndex].stepData.validation.url
	// init payload obj
	const payload: Record<string, any> = {};
	// build payload - @todo - abstract this
	Object.values(stepSummary).forEach(e => {
		const value = e?.originalField.fieldType === 'checkbox' ? (e.checked ? e.value : null) : e?.value;
		payload[e?.name as string] = value
	})
	const stepPayload: StepValidationPayload = {
		stepTemplate,
		payload,
	}
	// call validation endpoint
	const response = await Api.runAsyncValidation(endpoint, stepPayload)

	return response
});


const buildFormSubmitPayload = (summary: StepsState['formSummary']): FinalFormPayload => {
	const data: FinalFormPayload = {
		payload: {},
		formData: new FormData(),
	};

	const FILE_ATTACHMENTS: StepTemplate = 'FILE_ATTACHMENTS'

	for (const [key, elements] of Object.entries(summary.steps)) {

		data.payload[key] = {};

		for (const [fieldKey, field] of Object.entries(elements)) {
			const fieldType = field?.originalField.fieldType;

			data.payload[key][fieldKey] = {
				name: field!.name,
				value: field!.value,
				fieldType: fieldType!,
			}
			let checked = false;
			if (fieldType === 'checkbox') {
				checked = !!field?.checked
				data.payload[key][fieldKey]['checked'] = checked
			}

			// add to form data
			let formDataValue = data.payload[key][fieldKey].value;
			if (fieldType === 'checkbox' && checked === false) {
				// support for checkboxes/values
				formDataValue = '';
			}

			// append to form data
			if (key === FILE_ATTACHMENTS) {
				// get file values from the page
				const fileId = getFileslotId(field!.fileDetails!.fileIndex);
				// const theFile = document.getElementById('o-heating-form__file0')
				const theFile = document.getElementById(fileId) as HTMLInputElement;
				if (theFile && theFile.files && theFile.files[0]) {
					// data.formData.append(fieldKey, theFile.files[0])
					data.formData.append('files[]', theFile.files[0])
				}
			} else {
				data.formData.append(fieldKey, formDataValue);

			}
		}
	}
	return data;
}

export const submitForm = createAsyncThunk('heatingAppSlice/submitForm', async (_, thunkAPI) => {
	const state = thunkAPI.getState() as RootState;

	// get submit URL
	const endpoint: string = state.steps.formSubmitUrl;
	if (!endpoint) throw new Error('Missing form submit URL!')


	// build payload based on Redux data
	const payload = buildFormSubmitPayload(state.steps.formSummary);

	return await Api.submitFinalForm(endpoint, payload)
});

